import { Row } from "@tanstack/react-table";

const includesString = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: string,
) => {
  return String(row.getValue(columnId)).includes(filterValue);
};

const excludesString = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: string,
) => {
  return !String(row.getValue(columnId)).includes(filterValue);
};

const equalsString = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: unknown,
) => {
  return row.getValue(columnId) === filterValue;
};

const notEquals = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: unknown,
) => {
  return row.getValue(columnId) !== filterValue;
};

const lessThanOrEqual = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: unknown,
) => {
  return +(row.getValue(columnId) as number) <= +(filterValue as number);
};

const greaterThanOrEqual = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: unknown,
) => {
  return +(row.getValue(columnId) as number) >= +(filterValue as number);
};

const lessThan = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: unknown,
) => {
  return +(row.getValue(columnId) as number) < +(filterValue as number);
};

const greaterThan = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: unknown,
) => {
  return +(row.getValue(columnId) as number) > +(filterValue as number);
};

const isEmpty = <TData>(row: Row<TData>, columnId: string) => {
  return row.getValue(columnId) === "";
};

const isNotEmpty = <TData>(row: Row<TData>, columnId: string) => {
  return row.getValue(columnId) !== "";
};

export {
  includesString,
  excludesString,
  equalsString,
  notEquals,
  lessThanOrEqual,
  greaterThanOrEqual,
  lessThan,
  greaterThan,
  isEmpty,
  isNotEmpty,
};
